import { Box, Text, VStack } from '@chakra-ui/layout';
import { Textarea } from '@chakra-ui/react';

import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useFlag } from '@duke-hq/flags/react';
import { SubmittedFile } from '@duke-hq/ui/components/FileUpload/SubmittedFile';
import type { FormattedSlide } from './types';

export function FileUploadPromptAnswer({
  slide,
  answerInput,
  downloadFile,
  getFileUrl,
}: {
  slide: FormattedSlide;
  answerInput?: string;
  downloadFile: (fileId: string) => Promise<void>;
  getFileUrl?: (fileId: string) => Promise<string>;
}) {
  const canPlayMedia = useFlag('ASSESSMENT_MEDIA_RECORDING_RELEASE') === true;

  return (
    <VStack key={slide.slideId} spacing="4" alignItems="flex-start" mt="16px">
      <Text textStyle="md" fontWeight="semibold" color="fg.default">
        <Trans>Student file upload</Trans>
      </Text>
      <VStack w="full" h="full" gap="16px">
        {slide.answer?.files?.map((file) => (
          <SubmittedFile
            key={file.submissionFileId}
            filename={file.filename}
            mimetype={file.mimetype}
            sizeInBytes={file.sizeInBytes}
            onDownload={() => downloadFile(file.submissionFileId)}
            getPlaybackUrl={
              canPlayMedia && getFileUrl ? () => getFileUrl(file.submissionFileId) : undefined
            }
          />
        ))}
      </VStack>
      <Box w="full" h="full">
        <Text fontSize="md" color="fg.default" mb={4}>
          <Trans>Supporting text</Trans>
        </Text>
        <Textarea
          placeholder={t`Type your answer here`}
          disabled
          _disabled={{
            color: 'fg.default',
          }}
          value={answerInput}
        />
      </Box>
    </VStack>
  );
}
